import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'

// CVE-severity kleurschema — apart van SeoSeverityBadge's warning/notice/good
// schaal, want Trivy/OSV leveren critical/high/medium/low/unknown.
export const CVE_SEVERITY_CLASSES: Record<string, string> = {
  critical: 'bg-red-700 text-white',
  high: 'bg-red-500 text-white',
  medium: 'bg-orange-500 text-white',
  low: 'bg-yellow-500 text-white',
  unknown: 'bg-gray-400 text-white',
}

export function CveSeverityBadge({ severity, className }: { severity: string; className?: string }) {
  return (
    <Badge className={cn('shrink-0 uppercase', CVE_SEVERITY_CLASSES[severity] ?? 'bg-gray-400 text-white', className)}>
      {severity}
    </Badge>
  )
}
